import { render, staticRenderFns } from "./CreateFeed.vue?vue&type=template&id=e1562cf4&"
import script from "./CreateFeed.vue?vue&type=script&lang=ts&"
export * from "./CreateFeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports